let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("iYxvq")).then(() => parcelRequire('9AItb'));